<div class="explosive-container">
    <mt-filter
        [filterConfig]="filterConfig"
        [progressBar]="filterConfig.isLoading"
        (filterChange)="getReportExplosive($event)"
    ></mt-filter>
    <div
        class="explosive-table mt-4"
        *ngIf="tableConfig || message || systemError"
    >
        <div class="header-container">
            <div class="header">
                <div class="float-left">
                    <div class="title">
                        {{ "report-explosives" | lang | uppercase }}
                    </div>
                </div>
                <div
                    class="float-right"
                    *ngIf="tableConfig.dataset?.length > 0"
                >
                    <app-button-icon
                        [image]="'download'"
                        [iconType]="'icon'"
                        [disabled]="disabledExcelBtn"
                        [spinner]="btnSpinner"
                        (clickHandler)="downloadExcelFile()"
                    ></app-button-icon>
                </div>
            </div>
        </div>
        <div [ngClass]="{ 'body-container': tableConfig }">
            <app-main-table
                [tableConfig]="tableConfig"
                (sendInfoToComponent)="clickColumnHistorial($event)"
            >
            </app-main-table>
        </div>
    </div>
</div>
